import { render, staticRenderFns } from "./TreatmentSessionCompetencyTestMarking.vue?vue&type=template&id=23f9045c"
import script from "./TreatmentSessionCompetencyTestMarking.vue?vue&type=script&lang=js"
export * from "./TreatmentSessionCompetencyTestMarking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports